import styled from 'styled-components';

interface ToggleSwitchProps {
  /* 토글 스위치가 활성화 상태인지 체크함 true = 활성화 , false = 비활성화 */
  isChecked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}
const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  & input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  & .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
  }

  & .slider:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #2196f3;
  }

  input:checked + .slider:before {
    transform: translateX(26px);
  }
`;

function ToggleSwitch({ isChecked, onChange }: ToggleSwitchProps) {
  return (
    <Switch>
      <input type="checkbox" checked={isChecked} onChange={onChange} />
      <span className="slider"></span>
    </Switch>
  );
}
export default ToggleSwitch;
